import { Controller } from "@hotwired/stimulus"
import { jquery } from 'utils/jquery'

export default class extends Controller {
  static targets = [ "identifier" ]

  connect() {
    const $ = jquery();
    if (!$) {
      return;
    }

    let identifier = `#${this.identifierTarget.id}`;
    $(identifier).multipleSelect({
      allSelected: true,
      formatAllSelected: () => $(identifier).data('all-options-selector-message'),
      formatSelectAll: () => $(identifier).data('toggle-selector-message'),
      filter: $(identifier).data('keyword-filter'),
      maxHeight: '400',
      // Browser-QA bugfix (importation-overview follow-up) — multiple-select's own
      // "the selection settled" signal is `this.$el.trigger('change')`
      // (vendor/assets/javascripts/multiple-select.js:533-536), a jQuery-ONLY synthetic event:
      // jQuery's `.trigger()` never calls the native DOM `dispatchEvent` API for a plain 'change'
      // (there is no `elem.change()` method for jQuery to delegate to, unlike click/focus/blur),
      // so a Stimulus `data-action="change->..."` listener (native `addEventListener`) never sees
      // it — confirmed against the vendored source, not assumed. `onClick`/`onCheckAll`/
      // `onUncheckAll` (the plugin's own callback names — see the same vendor file's defaults
      // block) fire on every path that changes the selection (an item click, "select all", "clear
      // all"), so dispatching one real, bubbling, native `change` event here from each covers the
      // whole selection surface with a single, deliberate signal — Stimulus's delegated listener
      // on `.select_filters_and_keywords_container` picks it up regardless of which literal
      // descendant node the plugin itself reacts to internally.
      onClick: () => this.dispatchNativeChange(),
      onCheckAll: () => this.dispatchNativeChange(),
      onUncheckAll: () => this.dispatchNativeChange()
    });
  }

  dispatchNativeChange() {
    this.identifierTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
